<div *ngIf="(arrayOfSelectedConcepts$ | async).length > 0" class="container">
  <div class="filter-title">
    {{ 'FEASIBILITY.EDITOR.FILTER_SELECTION' | translate }}
    {{ (arrayOfSelectedConcepts$ | async).length }}
  </div>
  <div class="selected-filter-box">
    <div
      *ngFor="let selectedConceptFilter of arrayOfSelectedConcepts$ | async"
      fxLayout="row"
      fxLayoutAlign="start center"
      class="selected-filter-element"
    >
      <div fxFlex="60" class="display-part">
        <span
          matTooltipPosition="below"
          [matTooltip]="selectedConceptFilter.display | displayTranslation"
        >
          {{ selectedConceptFilter.display | displayTranslation }}
        </span>
      </div>
      <div fxFlex="30" class="display-part">
        {{ selectedConceptFilter.code }}
      </div>
      <div fxFlexAlign="end">
        <button (click)="removeSelectedConcept(selectedConceptFilter)" class="delete-button">
          {{ 'FEASIBILITY.EDITOR.MODAL.REMOVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
